module.exports = __webpack_public_path__ + "static/img/logo_new2.6485b7ff.png";